// Conversioni colore per colorPicker: accetta hex (3/4/6/8 cifre), rgb()/rgba() e nomi CSS,
// ed emette #rrggbb se opaco, altrimenti rgba(...) (formato che Fabric e l'export SVG gestiscono).

export interface Rgba {
    r: number;
    g: number;
    b: number;
    a: number;
}

const clamp = (v: number, min: number, max: number) => Math.min(max, Math.max(min, v));

export function parseColor(input: string): Rgba | null {
    if (!input || typeof input != 'string')
        return null;
    let s = input.trim().toLowerCase();
    if (!s || s == 'transparent' || s == 'none')
        return null;

    let m = s.match(/^#([0-9a-f]{3,8})$/);
    if (m) {
        let hex = m[1];
        if (hex.length == 3 || hex.length == 4)
            hex = hex.split('').map(c => c + c).join('');
        if (hex.length != 6 && hex.length != 8)
            return null;
        return {
            r: parseInt(hex.slice(0, 2), 16),
            g: parseInt(hex.slice(2, 4), 16),
            b: parseInt(hex.slice(4, 6), 16),
            a: hex.length == 8 ? round(parseInt(hex.slice(6, 8), 16) / 255) : 1,
        };
    }

    m = s.match(/^rgba?\(\s*([\d.]+)[\s,]+([\d.]+)[\s,]+([\d.]+)(?:[\s,/]+([\d.]+%?))?\s*\)$/);
    if (m) {
        let a = 1;
        if (m[4] != null)
            a = m[4].endsWith('%') ? parseFloat(m[4]) / 100 : parseFloat(m[4]);
        return {
            r: clamp(Math.round(+m[1]), 0, 255),
            g: clamp(Math.round(+m[2]), 0, 255),
            b: clamp(Math.round(+m[3]), 0, 255),
            a: clamp(round(a), 0, 1),
        };
    }

    // nomi CSS (es. "black"): li risolve il browser
    const ctx = document.createElement('canvas').getContext('2d');
    ctx.fillStyle = '#010203';
    ctx.fillStyle = s;
    const resolved = ctx.fillStyle as string;
    if (resolved == '#010203' && s != '#010203')
        return null;
    return parseColor(resolved);
}

function round(v: number) {
    return Math.round(v * 100) / 100;
}

const hex2 = (v: number) => v.toString(16).padStart(2, '0');

export function toHex6(c: Rgba) {
    return `#${hex2(c.r)}${hex2(c.g)}${hex2(c.b)}`;
}

export function toCss(c: Rgba) {
    return c.a >= 1 ? toHex6(c) : `rgba(${c.r}, ${c.g}, ${c.b}, ${round(c.a)})`;
}

/** Forma canonica di un colore (per confronti e palette), null se non è un colore. */
export function normalizeColor(input: string): string | null {
    const c = parseColor(input);
    return c ? toCss(c) : null;
}
